import { render } from "./FolderSettingsPopup.vue?vue&type=template&id=613c1392"
import script from "./FolderSettingsPopup.vue?vue&type=script&lang=js"
export * from "./FolderSettingsPopup.vue?vue&type=script&lang=js"

import "./FolderSettingsPopup.vue?vue&type=style&index=0&id=613c1392&lang=sass"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__